import type { ComponentProps } from 'react';
import { MdOutlineDarkMode, MdOutlineLightMode } from 'react-icons/md';
import { cn } from '@/components/ui';

export type ThemeModeIconProps = ComponentProps<typeof MdOutlineLightMode>;

/** Sun / “light mode” glyph (Material outline) — pair with `MoonIcon` on theme controls. */
export function SunIcon({ className, size = 16, ...rest }: ThemeModeIconProps) {
  return (
    <MdOutlineLightMode
      className={cn('shrink-0', className)}
      size={size}
      aria-hidden
      {...rest}
    />
  );
}

/** Moon / “dark mode” glyph (Material outline). */
export function MoonIcon({ className, size = 16, ...rest }: ThemeModeIconProps) {
  return (
    <MdOutlineDarkMode
      className={cn('shrink-0', className)}
      size={size}
      aria-hidden
      {...rest}
    />
  );
}
